import React, {Component} from 'react';
import T from 'i18n-react';
//Style
import './PdfViewerDialog.css'
//Components
import Loader from "react-loader";
import Dialog from 'material-ui/Dialog';
import {IconButton, RaisedButton} from "material-ui";
import {Document, Page} from 'react-pdf';
import COLORS from "../../enums/ColorEnum";
//Services

const dialogStyle = {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
};

class PdfViewerDialog extends Component {

    constructor(props) {
        super(props);

        this.state = {
            totalPages: null,
            pageNumber: null,
            loaded: false,
            file: null
        }
    }

    render() {
        const actions = [
            <RaisedButton
                label={T.translate('common.cancel')}
                onTouchTap={this.handleClose.bind(this)}
                className="action-button"
            />,
            <RaisedButton
                secondary
                label={T.translate('common.download')}
                disabled={!this.state.loaded}
                onTouchTap={this.props.download}
                className="action-button"
            />,
        ];

        return (
            <Dialog
                title={this.props.title}
                actions={actions}
                modal={false}
                open={this.props.show}
                onRequestClose={this.handleClose.bind(this)}
                autoScrollBodyContent={true}
                contentStyle={dialogStyle}
                className="pdfViewerDialog"
            >
            <Document
                file={this.props.file}
                onLoadSuccess={this.onDocumentLoadSuccess.bind(this)}
                loading={this.renderLoader()}
                noData={this.props.customErrorMessage || T.translate('pdfViewer.noDataMessage')}
                error={T.translate('pdfViewer.errorMessage')}
                onLoadError={console.error}
            >
                <Page pageNumber={this.state.pageNumber}/>
            </Document>
                {this.state.pageNumber && this.state.totalPages && this.state.totalPages > 1 &&
                    <div className="nav-container">
                        <div>
                            <IconButton
                                className="nav-arrow"
                                iconClassName="material-icons"
                                disabled={this.state.pageNumber <= 1}
                                onClick={this.previousPage.bind(this)}>
                                arrow_back
                            </IconButton>
                            <IconButton
                                className="nav-arrow"
                                iconClassName="material-icons"
                                disabled={this.state.pageNumber >= this.state.totalPages}
                                onClick={this.nextPage.bind(this)}>
                                arrow_forward
                            </IconButton>
                        </div>
                        <span>
                            {T.translate('pdfViewer.pagination', {'pageNumber': this.state.pageNumber, 'totalPages': this.state.totalPages})}
                        </span>
                    </div>
                }
            </Dialog>
        );
    }

    /***********************************************************
     ****************** Gestion du Document ********************
     **********************************************************/

    onDocumentLoadSuccess({numPages}) {
        this.setState({
            totalPages: numPages,
            pageNumber: 1,
            loaded: true
        })
    }

    renderLoader() {
        return  (
            <div className="mt-3">
                <Loader loaded={this.state.loaded} color={COLORS.GREEN}>
                </Loader>
                <div className="loader-message">
                    {T.translate('pdfViewer.loaderMessage')}
                </div>
            </div>
        )
    }

    changePage(offset) {
        this.setState((state) => ({
            pageNumber: state.pageNumber + offset
        }));
    }

    previousPage() {
        this.changePage(-1);
    }

    nextPage() {
        this.changePage(1);
    }

    handleClose() {
        this.setState({
            totalPages: null,
            pageNumber: null,
            loaded: false,
            file: null
        }, this.props.handleClose)

    }

}

export default PdfViewerDialog;


// WEBPACK FOOTER //
// ./src/components/pdfViewerDialog/PdfViewerDialog.js